import { defineComponent, unref, type MaybeRef } from 'vue'
import type { IProviderImportStepProps } from '../../types/stepProps'
import { ProviderImportCrumbs } from '../crumbs'
import { EProviderImportStep } from '../../types/steps';
import { computed } from 'vue';
import { useResponsive } from '~/composables/useResponsive';

export const StepWrapper = defineComponent<
  IProviderImportStepProps & {
    currentStep: MaybeRef<EProviderImportStep>;
    stepIndex: MaybeRef<number>
    titles: MaybeRef<string[]>;
    crumbs?: MaybeRef<boolean>;
    title?: MaybeRef<string>;
  }
>(
  (props, ctx) => {
    const responsive = useResponsive();
    const currentStep = computed(() => unref(props.currentStep));

    return () => {
      return (
        <div class="w-full flex flex-col items-center overflow-hidden flex-1 relative">
          <ProviderImportCrumbs
            hook={props.hook}
            stepIndex={props.stepIndex}
            titles={props.titles}
            class="shrink-0"
            crumbs={props.crumbs}
            title={props.title}
          />
          {
            [EProviderImportStep.SAVING, EProviderImportStep.CONNECTING].includes(currentStep.value) ? (
              <div class="w-full h-full flex-1 grid items-center justify-center">
                {ctx.slots.default ? ctx.slots.default() : ''}
              </div>
            )  : (
              <div class={[
                "w-full h-full flex-1 overflow-y-auto pretty-scrollbar",
                responsive.isSmall.value ? "py-8" : "pt-12 pb-6"
              ]}>
                {ctx.slots.default ? ctx.slots.default() : ''}
              </div>
            )
          }

        </div>
      )
    }
  },
  { props: ['hook', 'stepIndex', 'titles', 'crumbs', 'title', 'currentStep'] }
)
